import PropertyPalLogo from '@propertypal/shared/src/resources/logos/PropertyPalLogo@3x.png';
import { Heading, LinkText, SubHeading, Text } from '@propertypal/web-ui/src/typography';
import React from 'react';
import { Container, InfoBox, Logo, TitleHeader, WaysContainer } from './WaysToPayContent.style';

const WaysToPayContent = () => {
  return (
    <Container>
      <TitleHeader>
        <Logo src={PropertyPalLogo.src} width={256} height={68} alt="PropertyPal logo" />
        <Heading fontSize={36}>WAYS TO PAY</Heading>
        <Text fontSize={24} style={{ marginTop: '0.3em' }}>
          THERE ARE THREE WAYS TO PAY US
        </Text>
      </TitleHeader>

      <WaysContainer>
        <InfoBox>
          <SubHeading fontSize={31} style={{ marginBottom: '1em' }}>
            1. DIRECT DEBIT
          </SubHeading>
          <Text fontWeight="bold">Please visit the link below to complete the form:</Text>

          <LinkText href="https://xero.gocardless.com/pay/co/GEN9127760480">www.propertypal.com/directdebit</LinkText>

          <Text>
            Please note: Listing invoices not paid by Direct Debit will be subject to a £10 + VAT administration fee.
          </Text>
        </InfoBox>

        <InfoBox>
          <SubHeading fontSize={31} style={{ marginBottom: '1em' }}>
            2. CREDIT / DEBIT CARD
          </SubHeading>

          <Text>
            We accept all major credit and debit cards. You can pay any invoice by clicking on the payment button from
            within your digital invoice.
          </Text>
        </InfoBox>
      </WaysContainer>

      <WaysContainer>
        <InfoBox>
          <SubHeading fontSize={31} style={{ marginBottom: '1em' }}>
            3. CHEQUE
          </SubHeading>

          <Text style={{ margin: '0.5em 0' }}>
            <strong>Please make cheques payable to:</strong> <br />
            PropertyPal.com Ltd.
          </Text>

          <Text style={{ margin: '0.5em 0' }}>
            <strong>Postal Address:</strong>
            <br />
            PropertyPal.com,
            <br />
            Unit 2D Jennymount Business Park,
            <br />
            North Derby Street,
            <br />
            Belfast,
            <br />
            BT15 3HN
          </Text>
        </InfoBox>
      </WaysContainer>
    </Container>
  );
};

export default WaysToPayContent;
